import { useEffect } from 'react'
import { trackInternalEvent } from '@rio/tracking'
import { useI18n } from 'builder/hooks/useI18n'

import { TRANSLATION_KEY } from '../utils'
import { useTourConfig } from '../hooks/useTourConfig'
import IMAGE from '../assets/init-modal.png'
import * as Styles from './styles'

export const TourModal = () => {
  const { i18n } = useI18n()
  const { isStartModalOpen, toggleTour } = useTourConfig()

  const handleStartTour = () => {
    trackInternalEvent('click_rb_onboarding_modal')
    toggleTour({
      isRunning: true,
      isStartModalOpen: false,
      stepIndex: 0,
      stepName: 'design',
      isTourActive: true,
    })
  }

  useEffect(() => {
    trackInternalEvent('see_rb_onboarding_modal')
  }, [])

  if (!isStartModalOpen) return null

  return (
    <Styles.ModalContainer>
      <Styles.Modal isOpen={true}>
        <Styles.Container>
          <Styles.Content>
            <Styles.ImageContainer>
              <Styles.Image src={IMAGE} alt="Init Document Tour" />
            </Styles.ImageContainer>
            <Styles.TextContainer>
              <Styles.Title>{i18n.t(`${TRANSLATION_KEY}.modal.title`)}</Styles.Title>
              <Styles.Description>
                {i18n.t(`${TRANSLATION_KEY}.modal.description`)}
              </Styles.Description>
            </Styles.TextContainer>
          </Styles.Content>
          <Styles.Action onClick={handleStartTour}>
            {i18n.t(`${TRANSLATION_KEY}.modal.action`)}
          </Styles.Action>
        </Styles.Container>
      </Styles.Modal>
    </Styles.ModalContainer>
  )
}
